export function getLearnSkillList(state) {
  return state.learn_skill_list;
}

export function getPlanSkillList(state) {
  return state.plan_skill_list;
}

export function getGoalsSkillList(state) {
  return state.goals_skill_list;
}

export function getRateSkillList(state) {
  return state.rate_skill_list;
}

export function getSkillName(state) {
  return state.skill_name;
}

export function getSkillDescription(state) {
  return state.skill_description;
}

export function getPlanQuestionList(state) {
  return state.plan_question_list;
}

export function getPlanAnswers(state) {
  return state.plan_answers;
}

export function getRateQuestionList(state) {
  return state.rate_question_list;
}

export function getPracticeQuestionList(state) {
  return state.practice_question_list;
}

export function getQuestionsToSkip(state) {
  return state.questions_to_skip;
}

export function getRelatedPlanAnswers(state) {
  return state.related_plan_answers;
}

export function getPracticeAnswers(state) {
  return state.practice_answers;
}
